import { InternalTransferTransactionModelDto } from '@treasury/api/channel';
import { AddTransactionRequest, Transaction, TransferType } from '.';
import { DomainEntity } from '../shared';

export class Transfer extends DomainEntity<AddTransactionRequest> {
    constructor(dto: AddTransactionRequest = {} as AddTransactionRequest) {
        super(dto);
        this._transactions = (dto.transactions || [])
            .filter(t => (t.amount ?? 0) !== 0)
            .map(t => new Transaction(t));
    }

    private _transactions: Transaction[];

    public createDefault() {
        return new Transfer() as this;
    }

    public get isPendingApproval() {
        return this._transactions.some(t => t.status?.startsWith('Pending'));
    }

    public get transferId() {
        return this.dto.id;
    }

    public get transactions() {
        return this._transactions;
    }

    public set transactions(transactions: Transaction[]) {
        this._transactions = transactions;
        this.dto.transactions = transactions.map(t => t.toDto());
    }

    public get type() {
        return this.dto.type as TransferType;
    }

    public set type(type: TransferType) {
        this.dto.type = type;
    }

    public get templateId() {
        return this.dto.templateId;
    }

    public set templateId(templateId) {
        this.dto.templateId = templateId;
    }

    public get templateName() {
        return this.dto.templateName;
    }

    public set templateName(templateName) {
        this.dto.templateName = templateName;
    }

    public toUpdateDto(): {
        id: number;
        transactions: InternalTransferTransactionModelDto[];
    } {
        return {
            id: this.initialDto.id || 0,
            transactions: this._transactions.map(
                t => t.toDto() as InternalTransferTransactionModelDto
            ),
        };
    }

    public toDto() {
        // This is still needed to capture changes made directly to individual transactions
        // since the setter only works when setting the entire transactions array
        return {
            ...super.toDto(),
            transactions: this._transactions.map(t => t.toDto()),
        };
    }
}
